// UI strings for the content import (src/community/): the source line of a Peterson example or word
// that is not on the wiki, and the community examples ("Yhteisön esimerkit": the Juelos list, never
// Peterson's). Finnish (default) and English side by side; en has the same shape.
// Style: docs/FINNISH-STYLE.md.
import { defineArea } from '../area';

export const communityFi = {
  /** Source line under a verified Peterson example from outside the wiki. */
  peterson: 'Petersonin esimerkki',
  duolingo: 'Duolingon kurssi (Peterson)',
  /** The link to the post, talk or course page. */
  sourceLink: 'lähde',
  /** dt of the source row on a word's entry. */
  wordSource: 'Lähde',
  /** On a word's entry: it is Peterson's but not on the wiki. */
  notOnWiki: 'ei wikissä',
  flag: {
    corrected: 'Petersonin korjaama muoto',
    hedged: 'Peterson ei ollut täysin varma',
    romanised: 'kirjoitettu Petersonin ääntämysmerkinnästä',
    endorsed: 'kysyjän lause, Peterson vahvisti sen',
  } as Record<'corrected' | 'hedged' | 'romanised' | 'endorsed', string>,
  /** The English was pieced together from his comments, not given by him. */
  enResearch: 'englanninnos koottu Petersonin kommenteista',
  /** Collapsed section under a word's examples. */
  title: 'Yhteisön esimerkit',
  count: (n: number) => (n === 1 ? '1 lause' : `${n} lausetta`),
  /** The label every community example carries. */
  tag: 'yhteisö · ei Petersonin',
  by: 'Juelosin kokoelma, Language Invention Wiki',
  /** The credit of the Telltale game's lines (a fan transcription; Peterson did the game's Valyrian). */
  byTelltale: 'Telltale-pelin Game of Thrones repliikit fanin kirjaamina (Language Invention Wiki); kirjoitusasu ei ole varmasti Petersonin',
  /** Under a Telltale line: where in the game it is. */
  telltaleLine: (episode: number | undefined, speaker: string | undefined) =>
    ['Telltale-peli', episode ? `jakso ${episode}` : '', speaker ?? ''].filter(Boolean).join(' · '),
  /** Vapaa harjoitus: the line under an item built from a community example. */
  exerciseScene: 'yhteisön esimerkki · ei Petersonin',
};

export type CommunityMessages = typeof communityFi;

export const communityEn: CommunityMessages = {
  peterson: 'Peterson’s example',
  duolingo: 'Duolingo course (Peterson)',
  sourceLink: 'source',
  wordSource: 'Source',
  notOnWiki: 'not on the wiki',
  flag: {
    corrected: 'Peterson’s corrected form',
    hedged: 'Peterson was not quite sure',
    romanised: 'written from Peterson’s phonetic transcription',
    endorsed: 'the asker’s sentence, confirmed by Peterson',
  },
  enResearch: 'English pieced together from Peterson’s comments',
  title: 'Community examples',
  count: (n) => (n === 1 ? '1 sentence' : `${n} sentences`),
  tag: 'community · not Peterson’s',
  by: 'Juelos’s collection, Language Invention Wiki',
  byTelltale: 'Lines of the Telltale Game of Thrones game as transcribed by a fan (Language Invention Wiki); the spelling is not certainly Peterson’s',
  telltaleLine: (episode, speaker) => ['Telltale game', episode ? `episode ${episode}` : '', speaker ?? ''].filter(Boolean).join(' · '),
  exerciseScene: 'community example · not Peterson’s',
};

// Messages.community (i18n/area.ts: collected by area-registry.ts)
export const area = defineArea('community', communityFi, communityEn);
declare module '../area' {
  interface AreaMessages extends Record<typeof area.key, typeof communityFi> {}
}
